import React from 'react'

interface Prop{
    leftIcon?:string;
    rightIcon?:string

}
const iconProps = {
    castcoIcon:"/assets/login/icon/castco.svg",
    iotIcon:"/assets/login/icon/IoT.svg",
    verLine: "/assets/login/icon/verLine.svg",

}
export default function LoginIcons({leftIcon, rightIcon}:Prop) {
  return (
    <div className='h-full flex gap-3 items-center'>
        <img src={iconProps.castcoIcon} style={{width:"194px",height:"52px"}} />
        <img src={iconProps.verLine} />
        <img src={iconProps.iotIcon} />

    </div>
  )
}
